export default __webpack_public_path__ + "static/media/share.c77deb3d.mp4";